import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { createI18n as _createI18n, type I18n } from 'vue-i18n';

export function createI18n() {
  return _createI18n({
    silentFallbackWarn: true,
    missing: (currentLocale, key) =>
      console.warn(`Missing translations for "${key}" in "${currentLocale}"`),
    messages: {},
    warnHtmlInMessage: 'off',
  });
}

export async function safeLoadTranslations(i18n: I18n, locale: HgSupportedLanguage): Promise<void> {
  try {
    await loadTranslations(i18n, locale);
  } catch (err) {
    console.error('Could not load locales', err);
  }
}

async function loadTranslations(i18n: I18n, locale: HgSupportedLanguage): Promise<void> {
  // Vitest 4 runs Vite import analysis on this dynamic import before runtime.
  // Putting import.meta.env inside the template makes that transform fail to parse the file.
  const platform = import.meta.env.VUE_APP_PLATFORM;

  // eslint-disable-next-line import/dynamic-import-chunkname
  const localeLoaded = await import(`@/i18n/${locale}-${platform}.ts`);
  i18n.global.mergeLocaleMessage(locale, { ...localeLoaded.default });
}

export async function setLocaleBeforeRouteChange(
  i18n: I18n,
  locale: HgSupportedLanguage,
): Promise<void> {
  const currentMessages = i18n.global.getLocaleMessage(locale);
  if (Object.keys(currentMessages).length === 0) {
    await safeLoadTranslations(i18n, locale);
  }
}
